import { Component, Mixins } from 'vue-property-decorator'

import WebpartTemplate from '@webparts/components/webparts/base/WebpartTemplate.vue'
import WebpartBase from '@webparts/components/webparts/base/WebpartBase'
import FileList from './FileList.vue'

declare global {
    namespace graph {
        export type DriveItemsRequet = {
            items: DriveItemRequest[]
        }

        export type DriveItemRequest = {
            driveId: string;
            itemId: string;
        }

        export type DriveItem = {
            createdDateTime: string;
            name: string;
            id: string;
            webUrl: string;
            parentReference: {
                id: string;
                driveId: string;
                driveType: string;
                name: string;
            }
            lastModifiedDateTime: string;
            lastModifiedBy: null | {                                
                user: {
                    additionalData: {
                        email: string;
                    },
                    displayName: string;
                }
            }
        };
    }
}

@Component({
    components: {
        WebpartTemplate,
        FileList
    }
})
export default class RecentFilesWebpart extends Mixins(WebpartBase) {
    created() {
        this.loading = true;
    }         
    
    onListMounted() {
        this.loading = false;
    }
}